import { useCallback, useEffect, useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import SearchBar from "@Atom/SearchBar";
import JobSeekersCard from "@Molecule/JobSeekersCard";
import Images from "@Theme/Images";
import { getDataJobPostExternal } from "@Services/home";
import { capitalizedFirstLetter } from "@Helpers/capitalizedFirstLetter";
import { Button, Pagination } from "@mui/material";
import ImgSingleBag from "@Assets/Images/single-bag.png";
import { useNavigate } from "react-router-dom";
import Toast from "@Atom/Toast";
import EmptyData from "@Organism/Recruiter/PipelineDetail/EmptyData";
import moment from "moment";
import { useDebounce } from "@Hooks/useDebounce";
import { fileBaseUrl } from "@Config/api";

export default function OtherCompanyJobPosting() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [isLoadingGet, setIsLoadingGet] = useState(true);

  const [limit] = useState(10);
  const [pages, setPages] = useState(1);
  const [dataList, setDataList] = useState({ totalData: 0, totalPage: 1 });
  const debounceSearchQuery = useDebounce(search, 500);

  const refetchData = useCallback(
    async (isLoadingRefetch = true) => {
      setIsLoadingGet(isLoadingRefetch);
      try {
        const { response: res } = await getDataJobPostExternal(
          limit,
          pages,
          debounceSearchQuery
        );
        setData(res?.data);
        setDataList(res);
      } catch (error) {
        console.log("Error", error);
      } finally {
        setIsLoadingGet(false);
      }
    },
    [debounceSearchQuery, pages, limit]
  );

  useEffect(() => {
    refetchData(true);
  }, [refetchData]);

  useEffect(() => {
    setPages(1);
  }, [search]);

  const dataTemplate = useMemo(() => {
    return data?.map((el) => ({
      id: el?.id,
      name: capitalizedFirstLetter(el?.title),
      experience: el?.experience,
      workType: el?.workType,
      contractType: el?.contractType,
      workMethod: el?.workMethod || el?.workSystem,
      workSystem: el?.workSystem,
      client: el?.clientName,
      location: capitalizedFirstLetter(el?.placement),
      salary: `${el?.salary[0]} - ${el?.salary[1]}`,
      createdAt: el?.appliedDate
        ? moment(new Date(el?.appliedDate))?.format("D MMMM YYYY, HH:mm")
        : null,
      status: "Lamaran Terkirim",
      img: el?.iconUri
        ? fileBaseUrl + el?.iconUri
        : Images.PERAMATA_LOGO_CICRLE,
      jobPostID: el?.jobPostID,
      viewedAt: el?.viewedAt
        ? moment(new Date(el?.viewedAt))?.format("D MMMM YYYY, HH:mm")
        : "",
    }));
  }, [data]);

  const [error, setError] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      if (error) setError(false);
    }, 2000);
  }, [error]);

  const backToTop = (top = 0) => {
    return window.scrollTo({
      behavior: "smooth",
      top: top,
    });
  };

  useEffect(() => {
    backToTop();
  }, [pages]);

  return (
    <section className={Styles.flexCol}>
      <div className={Styles.right}>
        <div className={Styles.header}>
          <div className={Styles.left}>
            <span className={Styles.title}>Pekerjaan Dilamar</span>
            <span className={Styles.total}>{dataList?.totalData}</span>
          </div>

          <div className={Styles.rightHeader}>
            <SearchBar
              value={search}
              placeholder={"Cari nama pekerjaan atau perusahaan"}
              onChange={(e) => setSearch(e?.target?.value)}
            />
          </div>
        </div>

        <Toast
          isSent={error}
          label={"Job Posting Not Found"}
          bg="red"
          icon="cross-circle"
        />

        <div className={Styles.content}>
          {dataTemplate?.length === 0 && !isLoadingGet && !search ? (
            <EmptyHandler />
          ) : dataTemplate?.length === 0 && !isLoadingGet && search ? (
            <div className={Styles.wrapEmptyHandler}>
              <div className={Styles.wrapEmptyHandler}>
                <EmptyData
                  customLabel={
                    "Data pekerjaan dilamar yang anda cari tidak ada"
                  }
                />
              </div>
            </div>
          ) : (
            <div className={Styles.listBox}>
              {(isLoadingGet ? [1, 2] : dataTemplate)?.map((el, idx) => {
                return (
                  <JobSeekersCard
                    key={idx}
                    data={el}
                    loading={isLoadingGet}
                    isHistory
                  />
                );
              })}
              {dataTemplate.length === 1 &&
                Array.from({ length: 1 }).map((_, idx) => (
                  <div key={idx} className={Styles.cardFilledEmpty}></div>
                ))}
            </div>
          )}
        </div>
      </div>
      <div>
        <Pagination
          count={dataList?.totalPage}
          page={pages}
          onChange={(_, value) => setPages(value)}
          color="primary"
        />
      </div>
    </section>
  );
}

const EmptyHandler = () => {
  const navigate = useNavigate();
  return (
    <div className={Styles.wrapEmpty}>
      <img src={ImgSingleBag} alt="empty-handler-img" />
      <h2>Tidak Ada Loker Yang Dilamar</h2>
      <Button
        onClick={() => navigate("/job-seeker")}
        className={Styles.btn}
        variant="outlined"
      >
        Mulai Cari Loker
      </Button>
    </div>
  );
};
